import type { IconBaseProps } from "react-icons"
import { fieldTypeIcons } from "../utilities"

function DynamicIcon(props: IconBaseProps & { name: string }) {
  const Component = fieldTypeIcons[props.name]
  return <Component {...props} />
}

export default DynamicIcon
